import {HOST_API} from 'src/config-global';

const COMMENT_LIST_FOR_RECIPE_API_URI = '/api/comment/recipe/list';

export async function getCommentListForRecipe(commentData) {
  const params = {
    method: "POST",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      recipeId: commentData.recipeId,
      commentId: commentData.commentId,
      size: commentData.size
    })
  };

  if (localStorage.getItem('accessToken')) {
    params.headers.Authorization = `Bearer ${localStorage.getItem('accessToken')}`;
  }

  const response = await fetch(`${HOST_API}${COMMENT_LIST_FOR_RECIPE_API_URI}`, params);

  if (!response.ok) {
    if (response.status === 404) {
      return null;
    }

    let message = `${response.status}:${response.statusText}`;
    if (response.status < 500) {
      const responseData = await response.json();
      message = responseData.error;
    }

    throw new Error(message);
  }

  return response.json();
}

